import DiscordCommunity from "@/components/DiscordCommunity";
import SEO from "@/components/SEO";

const Community = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      <SEO 
        title="Discord Community - Join Elite Crypto Traders | Oraculus:X Trading Group"
        description="Join our cryptocurrency trading community on Discord. Share strategies, get live support, access exclusive channels, and connect with professional traders worldwide."
      />
      <div className="fixed inset-0 bg-gradient-mesh animate-mesh-move opacity-40" />
      <div className="fixed inset-0 bg-gradient-opal-radial animate-gradient-shift" style={{ backgroundSize: '200% 200%' }} />
      
      <main className="relative z-10 pt-20 md:pt-32">
        <DiscordCommunity />
      </main>
    </div>
  );
};

export default Community;
